"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = (0, _withTheme.default)(() => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
    id: "g446",
    transform: "matrix(0,1.2480369,-1,0,23.952978,-0.29342576)",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      strokeWidth: "1.58542931",
      id: "path389",
      d: "M 7.0434309,3 H 11.442207 A 1.2567931,2 0 0 1 12.699,5 v 14 a 1.2567931,2 0 0 1 -1.256793,2 H 7.0434309 m 0,-18 H 2.6446546 A 1.2567931,2 0 0 0 1.3878615,5 v 14 a 1.2567931,2 0 0 0 1.2567931,2 h 4.3987763 m 0,-18 v 18"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      strokeWidth: "1.58542931",
      id: "path389-1",
      d: "m 12.660028,3.0037932 h 4.398777 a 1.2567931,2 0 0 1 1.256793,2 V 19.003793 a 1.2567931,2 0 0 1 -1.256793,2 h -4.398777 m 0,-17.9999998 H 8.261252 a 1.2567931,2 0 0 0 -1.2567931,2 V 19.003793 a 1.2567931,2 0 0 0 1.2567931,2 h 4.398776 m 0,-17.9999998 V 21.003793"
    })]
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 17.564518,8.5043543 3.052667,6.4407907",
    id: "path456"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 15.266631,8.8398123 3.052667,6.4407917",
    id: "path456-5"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 12.683605,8.8062666 3.052667,6.4407904",
    id: "path456-4"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 10.436037,9.0746329 3.052667,6.4407911",
    id: "path456-9"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "M 7.8530118,8.8733581 10.905678,15.314149",
    id: "path456-44"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "m 5.4377158,8.9404497 3.052667,6.4407913",
    id: "path456-0"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeOpacity: "1",
    d: "M 3.4920578,9.5778197 6.5447248,16.01861",
    id: "path456-6"
  })]
}));